import { render, staticRenderFns } from "./recommend-result-jingqi.vue?vue&type=template&id=3d2f894e&scoped=true&"
import script from "./recommend-result-jingqi.vue?vue&type=script&lang=js&"
export * from "./recommend-result-jingqi.vue?vue&type=script&lang=js&"
import style0 from "./recommend-result-jingqi.vue?vue&type=style&index=0&id=3d2f894e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f894e",
  null
  
)

export default component.exports